import React, { useEffect, useState } from "react";
import "./Shop.css";
import apiRequest from "../../apiCall";
import config from "../../Admin/Config.json";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";

const Products = ({ excludeId, redirect }) => {
  const [products, setProducts] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!!excludeId) {
      apiRequest("GET", "recommended-products/", null, false, false)
        .then((res) => {
          dispatch(setLoading(true));
          if (Array.isArray(res.data)) {
            const filteredProducts = res.data.filter(
              (item) => item.heading.toLowerCase() !== excludeId.toLowerCase().replaceAll("-"," ")
            );
            setProducts(filteredProducts);
            dispatch(setLoading(false));
          } else {
            console.error("Error fetching recommended products: Invalid response data format");
            dispatch(setLoading(false));
          }
        })
        .catch(function (error) {
          console.error("Error fetching recommended products:", error);
          dispatch(setLoading(false));
        });
    }
  }, [excludeId]);

  return (
    products.length > 0 && (
      <div>
        <p className="shop-reco-h3">Recommend products</p>
        <div className="shop" style={{ overflow: "auto" }}>
          <div className="shop-reco-div1">
            {products.map((item) => (
              <div
                className="shop-reco-link"
                key={item.itemId}
                onClick={() => {
                  const productName = item.heading.replaceAll(" ", "-");
                  redirect(`/shop/${productName}`);
                }}
              >
                <div className="shop-reco-div">
                  <img
                    className="shop-reco-img"
                    src={config.awsMediaPath + item.productImage}
                    alt={item.heading}
                  />
                  <p className="shop-p-reco">{item.heading}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  );
};

export default Products;
